import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoadingService } from 'src/app/generales/services/loading.service';
import { AdminServiceService } from '../../service/admin-service.service';
import { UiService } from '../../service/ui.service';
import { BalanceComponent } from '../balance/balance.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  users: any[] = [];
  pag: number = 1;
  search = 'todos';


  constructor(
    private adminSv: AdminServiceService,
    private uiSv: UiService,
    private loadSv: LoadingService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.loadData();
  }

  async changePag(i) {
    if(i){
      this.pag = this.pag + 1;
    }else{
      if(this.pag === 1){
        return;
      }
      this.pag = this.pag - 1;
    }
    this.loadData();
  }

  async deleteUser(userId, userName){
    const { role } = await this.uiSv.presentAlert(`Eliminar usuario ${userName}`, '¿Deseas continuar?');
    if(role === 'accept'){
      await this.loadSv.show();
      this.adminSv.deleteUser({ id: userId }).subscribe(async res => {
        await this.loadSv.hide();
        this.users = this.users.filter(users => users.id !== userId );        
      }, async err => {
        await this.loadSv.hide();
      })
    }
  }

  loadData(){
    this.adminSv.getAllUsers(this.pag, this.search).subscribe((res: any) => {
      this.users = res.data.data;
    })
  }

  showBalance(id){
    this.adminSv.getBalance(id).subscribe(async (res: any) => {
      const modal = await this.modalController.create({
        component: BalanceComponent,
        componentProps: { data: res.data }
      });
      await modal.present();
    })
  }
}
